/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_flags/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureFlagsTags } from "./constants";
import type { EngagementAppGroupIdFeatureFlagsTagsResult } from "./types";

export const getEngagementAppGroupIdFeatureFlagsTags = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureFlagsTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementAppGroupIdFeatureFlagsTagsResult> => {
    return fetch(`/engagement/${appGroupId}/feature_flags/tags`, "GET", {}, { signal });
  }
);
